module.exports = {
  PAGE_NAME:{
    Success:'/order/success',
    Cancel:'/order/cancel',
    directSuccess:'/order/directsuccess',
    directCancel:'/order/directcancel'
},
  
  BASE_TEST_API_URL: "https://api.foloosi.com/store/v1",
  BASE_USER_TEST_API_URL: "https://api.foloosi.com/store",
  BASE_ORDER_TEST_API_URL: "https://api.foloosi.com/store",
  CHARGE_REQUEST_API_URL:'https://api.foloosi.com/store',
  CARD_DELETE_API_URL:'https://api.foloosi.com/store/customer/card/delete',  
  GUEST_CHECKOUT_URL:'https://api.foloosi.com/store/guest/proceed/order',
  /*BASE_TEST_API_URL: "https://roamsoft.co:8443/store/v1",
  BASE_USER_TEST_API_URL: "https://roamsoft.co:8443/store",
  BASE_ORDER_TEST_API_URL: "https://roamsoft.co:8443/store",
  CHARGE_REQUEST_API_URL:'https://roamsoft.co:8443/v1',
  CARD_DELETE_API_URL:'https://roamsoft.co:8443/store/customer/card/delete',*/
  //USER_URL:"https://marketplace.roamsoft.co", 
  USER_URL:"https://marketplace.foloosi.com",
  GET_COUNTRY :'https://pro.ip-api.com/json?key=RMV9nkZYs1rNPZQ',
  // USER_URL:"http://localhost:3000",
  CLOUDINARY: {
    cloudName: 'foloosi',
    apiKey: '724539947133222',
    uploadPreset: 'ifslewdl',
    folder: 'foloosi',
    url: 'https://res.cloudinary.com/foloosi/image/upload'
  }
}